import "../../../vendor/assets/javascripts/i18n";
import { extend } from "lodash";

// Remove js. scope from all translations
for (let lang in I18n.translations) {
  const translations = I18n.translations[lang];
  I18n.translations[lang] = extend({}, translations, translations.js);
}
